const PATH = 'fe.components.measure.home.create_button';

const messages = {
  createObservation: {
    key: `${PATH}.create_observation`,
    defaultValue: 'Create Observation'
  },
  informalClass2ndEdition: {
    key: `${PATH}.informal_class_2nd_edition`,
    defaultValue: 'CLASS 2nd Edition - Informal'
  },
  selectAccount: {
    key: `${PATH}.select_account`,
    defaultValue: 'Select an account'
  }
};

export default messages;
